import React from 'react'
import classNames from 'classnames'
import GoogleMapReact from 'google-map-react'
import MediaQuery from 'react-responsive'
import mediaSize from '../../../constants/mediaSize'

import styles from './styles.module.scss'

import uaeFlag from './img/flags/uae.svg'

import Parallax from '../../../constants/parallax'

export default class Information extends React.PureComponent {
  mapOptions = {
    mapTypeControl: false,
    zoomControl: false,
    fullscreenControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
  }

  coordinates = {
    // kazahstan: {
    //   lat: 43.2452262,
    //   lng: 76.936662,
    // },
    // canada: {
    //   lat: 49.2831963,
    //   lng: -123.110158,
    // },
    russia: {
      lat: 51.6713743,
      lng: 39.2030245,
    },
    uae: {
      lat: 25.069011,
      lng: 55.1407457,
    },
  }

  constructor(props) {
    super(props)
    this.parallaxComponents = [
      React.createRef(),
      React.createRef(),
      React.createRef(),
      React.createRef(),
      React.createRef(),
      React.createRef(),
    ]
  }

  componentDidMount() {
    const { init, cleanup } = new Parallax(this.parallaxComponents)
    init()
    this.cleanupParallax = cleanup
  }

  componentWillUnmount() {
    this.cleanupParallax()
  }

  render() {
    const {
      mapOptions,
      coordinates,
    } = this
    return (
      <div className={styles.wrap}>
        <MediaQuery minWidth={mediaSize.maxPhoneSize}>
          <div className={styles.logoBobbleWrap}>
            <div className="base-layout">
              <img
                alt="blobTop"
                src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/innerPages/blob_top.png`}
                className={styles.blobTop}
                width={190}
              />
              <img
                alt="pinBig"
                src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/innerPages/pin_big.webp`}
                className={styles.illustrationPin}
              />
            </div>
          </div>
          <img
            alt="waveTop"
            src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/innerPages/wave_top.webp`}
            className={styles.waveTop}
          />
          <div className={styles.bobblesWrap}>
            <div className="base-layout">
              <div className={styles.bobbles}>
                <div
                  ref={this.parallaxComponents[0]}
                  data-parallax="8"
                  className={classNames(styles.bobble, styles.bobbleFirst)}
                >
                  <img
                    alt="firstIcon"
                    width={35}
                    /* eslint-disable-next-line max-len */
                    src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/contacts/information/header/first.png`}
                  />
                </div>
                <div
                  ref={this.parallaxComponents[1]}
                  data-parallax="4"
                  className={classNames(styles.bobble, styles.bobbleSecond)}
                >
                  <img
                    alt="secondIcon"
                    width={25}
                    /* eslint-disable-next-line max-len */
                    src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/contacts/information/header/second.png`}
                  />
                </div>
                <div
                  ref={this.parallaxComponents[2]}
                  data-parallax="4"
                  className={classNames(styles.bobble, styles.bobbleThird)}
                >
                  <img
                    alt="thirdIcon"
                    width={31}
                    /* eslint-disable-next-line max-len */
                    src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/contacts/information/header/third.png`}
                  />
                </div>
                <div
                  ref={this.parallaxComponents[3]}
                  data-parallax="8"
                  className={classNames(styles.bobble, styles.bobbleFourth)}
                >
                  <img
                    alt="fourthIcon"
                    width={31}
                    /* eslint-disable-next-line max-len */
                    src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/contacts/information/header/fourth.png`}
                  />
                </div>
                <div
                  ref={this.parallaxComponents[4]}
                  data-parallax="8"
                  className={classNames(styles.bobble, styles.bobbleFifth)}
                >
                  <img
                    alt="fifthIcon"
                    width={30}
                    /* eslint-disable-next-line max-len */
                    src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/contacts/information/header/fifth.png`}
                  />
                </div>
                <div
                  ref={this.parallaxComponents[5]}
                  data-parallax="4"
                  className={classNames(styles.bobble, styles.bobbleSixth)}
                >
                  <img
                    alt="sixthIcon"
                    width={45}
                    /* eslint-disable-next-line max-len */
                    src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/contacts/information/header/sixth.png`}
                  />
                </div>
              </div>
            </div>
          </div>
        </MediaQuery>
        <div className={styles.content}>
          <div className="base-layout">
            <div>

              <div className={styles.row}>
                <div className={classNames(styles.card, styles.cardInfo, styles.cardInfoTop)}>
                  <MediaQuery minWidth={mediaSize.maxPhoneSize}>
                    <img
                      alt="card"
                      /* eslint-disable-next-line max-len */
                      src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/contacts/information/cardBg.svg`}
                      className={styles.cardInfoBg}
                    />
                  </MediaQuery>
                  <img
                    alt="UAE"
                    /* eslint-disable-next-line max-len */
                    src={uaeFlag}
                    className={styles.cardTextFlag}
                  />
                  <div className={styles.cardContent}>
                    <h2 className={styles.cardTitle}>
                      { 'PAYTOME DMCC' }
                    </h2>
                    <p className={styles.cardText}>
                      { 'По вопросам платежей вам поможет наша международная компания, '
                        + 'зарегистрированная в\u00A0красивом городе Дубай (ОАЭ).' }
                    </p>
                    <hr className={styles.cardHr} />
                    <pre className={styles.cardText}>
                      <MediaQuery minWidth={mediaSize.maxPhoneSize}>
                        { 'RN DMCC199423  /  LN DMCC-927507\n'
                          + '\n' }
                        {'\nE-mail: office@tome.ae'}
                        { '\nUT-11-PO-11, DMCC Business Centre, Dubai, UAE' }
                      </MediaQuery>
                      <MediaQuery maxWidth={mediaSize.maxPhoneSize - 1}>
                        { 'RN DMCC199423\n'
                          + 'LN DMCC-927507\n'
                          + '\n' }
                        { '\nE-mail: office@tome.ae'}
                        { '\nUT-11-PO-11,'}
                        { '\nDMCC Business Centre,'}
                        { '\nDubai, UAE' }
                      </MediaQuery>
                    </pre>
                  </div>
                </div>
                <div className={classNames(styles.card, styles.cardMap, styles.cardMapTop)}>
                  <GoogleMapReact
                    bootstrapURLKeys={{ key: 'AIzaSyDO8F6GdMJ-ywMfoTRfrf-O9dmf1uMXj1o' }}
                    defaultCenter={coordinates.uae}
                    defaultZoom={16}
                    options={mapOptions}
                  >
                    <img
                      lat={coordinates.uae.lat}
                      lng={coordinates.uae.lng}
                      alt="pinMap"
                      /* eslint-disable-next-line max-len */
                      src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/contacts/information/pinMap.svg`}
                      className={styles.cardMapPin}
                    />
                  </GoogleMapReact>
                </div>
              </div>

              <div className={styles.row}>
                <div className={classNames(styles.card, styles.cardInfo, styles.cardInfoBottom)}>
                  <MediaQuery minWidth={mediaSize.maxPhoneSize}>
                    <img
                      alt="card"
                      /* eslint-disable-next-line max-len */
                      src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/contacts/information/cardBg.svg`}
                      className={styles.cardInfoBg}
                    />
                  </MediaQuery>
                  <img
                    alt="russia"
                    /* eslint-disable-next-line max-len */
                    src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/contacts/information/flags/russia.svg`}
                    className={styles.cardTextFlag}
                  />
                  <div className={styles.cardContent}>
                    <h2 className={styles.cardTitle}>
                      { 'OOO «TOME»' }
                    </h2>
                    <p className={styles.cardText}>
                      { 'По вопросам выплат самозанятым вам поможет наша '
                        + 'Российская компания, зарегистрированная в\u00A0прекрасном городе Воронеж.' }
                    </p>
                    <hr className={styles.cardHr} />
                    <pre className={styles.cardText}>
                      <MediaQuery minWidth={mediaSize.maxPhoneSize}>
                        { 'ИНН 3666233589 / ОГРН 1193668003583\n'
                          + '\n'}
                        {'\n'}
                        {'E-mail: office@tome.ru'}
                        {'\n394036, г. Воронеж, Комиссаржевской, 10, оф. 1203'}
                      </MediaQuery>
                      <MediaQuery maxWidth={mediaSize.maxPhoneSize - 1}>
                        { 'ИНН 3666233589\n'
                          + 'ОГРН 1193668003583\n'
                          + '\n' }
                        {'\n'}
                        { 'E-mail: office@tome.ru' }
                        { '\n394036, г. Воронеж,'
                          + '\nКомиссаржевской, 10,'
                          + '\nофис 1203' }
                      </MediaQuery>
                    </pre>
                  </div>
                </div>
                <div className={classNames(styles.card, styles.cardMap, styles.cardMapBottom)}>
                  <GoogleMapReact
                    bootstrapURLKeys={{ key: 'AIzaSyDO8F6GdMJ-ywMfoTRfrf-O9dmf1uMXj1o' }}
                    defaultCenter={coordinates.russia}
                    defaultZoom={16}
                    options={mapOptions}
                  >
                    <img
                      lat={coordinates.russia.lat}
                      lng={coordinates.russia.lng}
                      alt="pinMap"
                      /* eslint-disable-next-line max-len */
                      src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/contacts/information/pinMap.svg`}
                      className={styles.cardMapPin}
                    />
                  </GoogleMapReact>
                </div>
              </div>

            </div>
            <MediaQuery minWidth={mediaSize.maxPhoneSize}>
              <img
                alt="blobBottom"
                width={187}
                /* eslint-disable-next-line max-len */
                src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/contacts/information/blob_bottom.png`}
                className={styles.blobBottom}
              />
            </MediaQuery>
          </div>
        </div>
        <MediaQuery minWidth={mediaSize.maxPhoneSize}>
          <img
            alt="waveBottom"
            src={`https://cdn.tome.${window.location.hostname.split('.').at(-1)}/landing/innerPages/wave_bottom.webp`}
            className={styles.waveBottom}
          />
        </MediaQuery>
      </div>
    )
  }
}
